"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var useStyles = (0, makeStyles_1.default)({
    root: {
        lineHeight: 'initial',
        textTransform: 'capitalize',
    },
});
var LocaleMenuItem = function (_a) {
    var locale = _a.locale, selected = _a.selected;
    var dispatch = (0, react_redux_1.useDispatch)();
    var classes = useStyles();
    var onClick = function () {
        dispatch({ type: 'PREFERRED_LOCALE_SET', preferredLocale: locale });
    };
    return (react_1.default.createElement(MenuItem_1.default, { className: classes.root, onClick: onClick, selected: selected }, getLanguageName(locale)));
};
function getLanguageName(locale) {
    var languageNames = new Intl.DisplayNames([locale], { type: 'language' });
    return languageNames.of(locale);
}
exports.default = LocaleMenuItem;
